import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 排名（院校列表查询）
 * @param {*} query
 */
export const rankcollegelist = (query) => {
    return request({
        url: `${prefix}/rank/college/list`,
        method: 'get',
        params: query
    })
}

/**
 * 排名（院校学院列表查询）
 * @param {*} query
 */
export const rankacademylist = (query) => {
    return request({
        url: `${prefix}/rank/college/academy/list`,
        method: 'get',
        params: query
    })
}


/**
 * 排名（院校专业列表查询）
 * @param {*} query
 */
export const rankmajorlist = (query) => {
    return request({
        url: `${prefix}/rank/college/major/list`,
        method: 'get',
        params: query
    })
}

/**
 * 排名（查询学生成绩列表）
 * @param {*} query
 */
export const rankuserlist = (query) => {
    return request({
        url: `${prefix}/rank/list`,
        method: 'get',
        params: query
    })
}


/**
 * 排名（专业门类一级查询）
 * @param {*} query
 */
export const levelOnelist = (query) => {
    return request({
        url: `${prefix}/rank/major/levelOne/list`,
        method: 'get',
        params: query
    })
}

/**
 * 排名（专业门类二级查询）
 * @param {*} query
 */
export const levelTwolist = (query) => {
    return request({
        url: `${prefix}/rank/major/levelTwo/list`,
        method: 'get',
        params: query
    })
}

/**
 * 排名（专业门类三级查询）
 * @param {*} query
 */
export const levelThreelist = (query) => {
    return request({
        url: `${prefix}/rank/major/levelThree/list`,
        method: 'get',
        params: query
    })
}

/**
 * 排名（删除学生成绩）
 * @param {*} query
 */
export const rankdelete = (query) => {
    return request({
        url: `${prefix}/rank`,
        method: 'delete',
        data: query
    })
}

/**
 * 排名（修改学生成绩）
 * @param {*} query
 */
export const rankput = (query) => {
    return request({
        url: `${prefix}/rank`,
        method: 'put',
        data: query
    })
}

/**
 * 查看配置年份
 * @param {*} query
 */

export const adjustConfigList = (query) => {
    return request({
        url: `${prefix}/adjustConfig`,
        method: 'get',
        params: query
    })
}

//排名-成绩审核接口
export const ScoreCheck = (query) => {
    return request({
        url: `${prefix}/rank26/rank/checkScore`,
        method: 'post',
        data: query
    })
}
//排名-查排名成绩批量审核接口
export const allScoreCheck = (query) => {
    return request({
        url: `${prefix}/rank26/rank/checkScore/bulk`,
        method: 'post',
        data: query
    })
}
//排名-成绩审核 根据排名查询审核列表详情
export const getExtendById = (query) => {
    return request({
        url: `${prefix}/rank/extendById`,
        method: 'get',
        params: query
    })
}
